// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"CoachDetailMain_mainContent__2t2-t","content":"CoachDetailMain_content__33jWR","links":"CoachDetailMain_links___XVwA"};